// Updated by Elevate: 2026-01-02T23:25:06.198Z
// Lazy load Google Fonts for better performance
//
// Performance note (QA audit):
// This file used to request FOUR Google Fonts stylesheets. An audit of the
// rendered storefront found that the "Material Symbols Rounded" and
// "Material Symbols Sharp" families had ZERO usages anywhere on the site,
// so they were removed. That saves 2 external stylesheet requests plus the
// font files they pull in, with no visual change.
//
// The "Material Icons" stylesheet is KEPT even though the classes are not
// currently rendered, because several section settings still expose
// icon_style: "material-icons" / "material-icons-outlined" as options.
// The "Material Symbols Outlined" stylesheet is KEPT because the
// .material-symbols-outlined class is actively used.
(function() {
  'use strict';

  // Check if fonts are already loaded
  function isFontLoaded(href) {
    const links = document.querySelectorAll('link[rel="stylesheet"]');
    for (let link of links) {
      if (link.href && link.href.includes(href)) {
        return true;
      }
    }
    return false;
  }

  // Load fonts with requestIdleCallback for better performance
  function loadFonts() {
    const fontsToLoad = [
      // Material Icons and variants
      'https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round|Material+Icons+Sharp|Material+Icons+Two+Tone',
      // Material Symbols - only the Outlined variant is used by this theme
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200'
    ];

    fontsToLoad.forEach(function(fontUrl) {
      // Skip if already loaded
      if (isFontLoaded(fontUrl)) return;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrl + '&display=swap'; // Add font-display: swap
      link.media = 'print'; // Load as print first
      link.onload = function() {
        this.media = 'all'; // Switch to all media when loaded
        this.onload = null; // Prevent multiple calls
      };

      // Add crossorigin for Google Fonts
      if (fontUrl.includes('fonts.googleapis.com')) {
        link.crossOrigin = 'anonymous';
      }

      document.head.appendChild(link);
    });
  }

  // Use requestIdleCallback if available, otherwise use setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadFonts, { timeout: 3000 });
  } else {
    setTimeout(loadFonts, 100);
  }
})();